import React, { useEffect, useState } from 'react'
import { Collapse } from '@mui/material'
import Steps from './components/Steps'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'
import SidebarCosts from './components/SidebarCosts'
import MilesBonusIcon from '../Base/IconComponents/MilesBonusIcon'
import isTransmissionAuto from '../../../js/helpers/isTransmissionAuto'

const BookingConfirmation = () => {
  const {
    dictionary,
    configuration,
    pickUpDetails,
    dropOffDetails,
    brands,
    types,
    thankYouData,
    reservationData,
  } = window.bookingData

  const { milesNBonusAccount } = window?.headerData || {}

  const [toggleSummary, setToggleSummary] = useState(true)
  const [toggleCarDetails, setToggleCarDetails] = useState(true)
  const [toggleDriverDetails, setToggleDriverDetails] = useState(true)

  const { confirmationPageType } = configuration

  const {
    vehicle: selectedVehicle,
    personalDetails,
    isPrepaid,
    reservationNumber,
    referenceNumber,
    mbData,
  } = reservationData

  const { brandName, car } = selectedVehicle
  const { prepaidPrice, returnPrice } = car

  useEffect(() => {
    if (!dataAvailability) {
      window.location.href = '/'
    }
  }, [])

  const handleSummaryClick = () => {
    setToggleSummary(!toggleSummary)
  }

  const handleCarDetailsClick = () => {
    setToggleCarDetails(!toggleCarDetails)
  }

  const handleDriverDetailsClick = () => {
    setToggleDriverDetails(!toggleDriverDetails)
  }

  const dataAvailability = () => {
    return selectedVehicle && personalDetails
  }

  const getBrand = () => {
    return brands?.find((b) => b.brandCode === brandName)
  }

  const thankYouMessage = () => {
    return dictionary?.confirmationMessage?.replace(
      '{0}',
      personalDetails.firstName
    )
  }

  const confrimationEmail = () => {
    const text =
      car.availability === 3
        ? dictionary.confirmationOnRequestMessage
        : dictionary.confirmationEmailText
    return text.replace('{0}', `<b>${personalDetails.email}</b>`)
  }

  const prepaidIncludes = () => {
    const includes = prepaidPrice.prepaidIncludes.split(',')
    return includes
  }
  // const prepaidIncludes = prepaidPrice.prepaidIncludes.split(',')

  const returnIncludes = () => {
    const includes = returnPrice.returnIncludes.split(',')
    return includes
  }
  // const returnIncludes = returnPrice.returnIncludes.split(',')

  const getMilesAccrual = () => {
    if (mbData) {
      const formatedMilesAccrual = mbData.milesAccrual.toLocaleString(
        window.lang
      )
      return dictionary.milesAccrualLabel.replace('{0}', formatedMilesAccrual)
    }
    return ''
  }

  const getMilesAccrualText = () => {
    if (mbData) {
      return dictionary.milesAccrualText.replace('{0}', mbData.milesNBonusId)
    }
    return ''
  }

  const handlePrintClick = (e) => {
    e.preventDefault()
    window.print()
  }

  return (
    <>
      <Steps
        currentStep={confirmationPageType === 'booking' ? 4 : 3}
        type={confirmationPageType === 'booking' ? 'booking' : 'cancel'}
        disableSteps={true}
      />

      {dataAvailability() && (
        <>
          <div className="s-booking-confirmation">
            <div className="page-container">
              <div className="s-booking-confirmation__thank-you">
                {confirmationPageType === 'booking' && (
                  <>
                    <div className="s-booking-confirmation__thank-you__image">
                      {thankYouData && (
                        <img
                          src={thankYouData.image.url}
                          alt={thankYouData.image.alt}
                        />
                      )}
                    </div>

                    <div className="s-booking-confirmation__thank-you__message">
                      <span className="s-booking-confirmation__thank-you__message__title">
                        {thankYouMessage()}
                      </span>
                      <SanitizeHtml
                        html={confrimationEmail()}
                        tag="span"
                        className="s-booking-confirmation__thank-you__message__text"
                      />
                    </div>
                  </>
                )}
                {confirmationPageType === 'cancel' && (
                  <>
                    <div className="s-booking-confirmation__thank-you__message">
                      <span className="s-booking-confirmation__thank-you__message__title">
                        {dictionary.cancelMessage}
                      </span>
                      <SanitizeHtml
                        html={confrimationEmail()}
                        tag="span"
                        className="s-booking-confirmation__thank-you__message__text"
                      />
                    </div>
                  </>
                )}
                <div className="s-booking-confirmation__thank-you__help">
                  <span className="s-booking-confirmation__thank-you__help__title">
                    {dictionary.confirmationQuestionsLabel}
                  </span>
                  <SanitizeHtml
                    html={dictionary.confirmationQuestionsText}
                    tag="span"
                    className="s-booking-confirmation__thank-you__help__text"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="page-container">
            <div className="s-booking-confirmation__separator"></div>
          </div>

          <div className="s-booking-confirmation__print">
            <div className="page-container">
              <div className="row s-booking-confirmation__print__content">
                <div className="col-lg-3 s-booking-confirmation__print__group">
                  <span className="s-booking-confirmation__print__group__title">
                    {dictionary.confirmationReservationNumberLabel}
                  </span>
                  <span className="s-booking-confirmation__print__group__value  ">
                    {reservationNumber}
                  </span>
                </div>
                <div className="col-lg-3 s-booking-confirmation__print__group">
                  <span className="s-booking-confirmation__print__group__title">
                    {dictionary.confirmationReferenceNumberLabel}
                  </span>
                  <span className="s-booking-confirmation__print__group__value">
                    {referenceNumber}
                  </span>
                </div>
                <div className="offset-lg-4 col-lg-2 s-booking-confirmation__print__btn">
                  <button
                    className="btn btn-outline-primary btn-full-width"
                    onClick={handlePrintClick}>
                    {dictionary.confirmationPrintButtonLabel}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="s-booking-confirmation__separator--sections d-lg-none d-block"></div>

          {(pickUpDetails || dropOffDetails) && (
            <div className="s-booking-confirmation__accordion">
              <div className="row" onClick={handleSummaryClick}>
                <div className="mb-24 d-flex align-items-center justify-content-between">
                  <span className="s-booking-form__form-group__title">
                    {dictionary.confirmationLocationsLabel}
                  </span>
                  <i
                    className={`icon-arrow-down arrow ${
                      toggleSummary ? 'open' : ''
                    }`}
                  />
                </div>
              </div>

              <Collapse in={toggleSummary}>
                <div className="s-booking-confirmation__wrapper">
                  <div className="s-booking-confirmation__locations">
                    {pickUpDetails && (
                      <>
                        <div className="s-booking-confirmation__location">
                          <div className="s-booking-confirmation__location__title">
                            {dictionary.pickUpLocationLabel}
                          </div>
                          <ul className="s-booking-confirmation__location__list">
                            <li>
                              <div className="pair">
                                <i className="icon-location"></i>
                                <span>{pickUpDetails.address}</span>
                              </div>
                            </li>
                            <li>
                              <div className="pair">
                                <i className="icon-calendar"></i>
                                <span>
                                  {pickUpDetails.date}, {pickUpDetails.time}
                                </span>
                              </div>
                            </li>
                            {pickUpDetails.tel && (
                              <li>
                                <div className="pair">
                                  <i className="icon-phone"></i>
                                  <span>{pickUpDetails.tel}</span>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </>
                    )}
                    <div className="s-booking-confirmation__separator"></div>
                    {dropOffDetails && (
                      <>
                        <div className="s-booking-confirmation__location">
                          <div className="s-booking-confirmation__location__title">
                            {dictionary.dropOffLocationLabel}
                          </div>
                          <ul className="s-booking-confirmation__location__list">
                            <li>
                              <div className="pair">
                                <i className="icon-location"></i>
                                <span>{dropOffDetails.address}</span>
                              </div>
                            </li>
                            <li>
                              <div className="pair">
                                <i className="icon-calendar"></i>
                                <span>
                                  {dropOffDetails.date}, {dropOffDetails.time}
                                </span>
                              </div>
                            </li>
                            {dropOffDetails.tel && (
                              <li>
                                <div className="pair">
                                  <i className="icon-phone"></i>
                                  <span>{dropOffDetails.tel}</span>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Collapse>
            </div>
          )}

          <div className="s-booking-confirmation__separator--sections d-lg-none d-block"></div>

          <div className="s-booking-confirmation__accordion">
            <div className="row" onClick={handleCarDetailsClick}>
              <div className="mb-24 d-flex align-items-center justify-content-between">
                <span className="s-booking-form__form-group__title">
                  {dictionary.confrimationCarDetailsLabel}
                </span>
                <i
                  className={`icon-arrow-down arrow ${
                    toggleCarDetails ? 'open' : ''
                  }`}
                />
              </div>
            </div>

            <Collapse in={toggleCarDetails}>
              <div className="s-booking-confirmation__wrapper">
                <div className="s-booking-confirmation__car">
                  <div className="s-booking-confirmation__car__left">
                    <div className="row">
                      <div className="col-lg-3 d-none d-lg-block">
                        <div className="s-booking-confirmation__car__image">
                          <img src={car.modelImage} alt={car.model} />
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className="s-booking-confirmation__car__details">
                          <div className="s-booking-confirmation__car__details__title">
                            <div className="s-booking-confirmation__car__details__model">
                              <span>{car.model} </span>
                              {/* <span className="s-booking-confirmation__car__details__model--similar">
                                  {selectedVehicle.similarText}
                                </span> */}
                            </div>
                            <div className="s-booking-confirmation__car__details__logo">
                              {getBrand() && (
                                <img
                                  src={getBrand().brandLogo}
                                  alt={getBrand().brandCode}
                                  loading="lazy"
                                />
                              )}
                            </div>
                          </div>
                          <div className="s-booking-confirmation__car__details__group">
                            {/* <span>{selectedVehicle.groupAcrissTxt}</span> */}
                          </div>
                          <ul className="s-booking-confirmation__car__details__list">
                            {car.passengers && (
                              <li>
                                <div className="pair">
                                  <i className="icon-passenger"></i>
                                  <span>{car.passengers}</span>
                                </div>
                              </li>
                            )}
                            {(car.bigLuggage > 0 || car.smallLuggage > 0) && (
                              <li>
                                {car.bigLuggage > 0 && (
                                  <div className="pair">
                                    <i className="icon-suitcase"></i>
                                    <span>x{car.bigLuggage}</span>
                                  </div>
                                )}
                                {car.smallLuggage > 0 && (
                                  <div className="pair">
                                    <i className="icon-suitcase"></i>
                                    <span>x{car.smallLuggage}</span>
                                  </div>
                                )}
                              </li>
                            )}
                            {car?.acriss && (
                              <li>
                                <div className="pair">
                                  <i className="icon-transmission"></i>
                                  <span>
                                    {isTransmissionAuto({ acriss: car.acriss })
                                      ? dictionary.transmissionAutomatic
                                      : dictionary.transmissionManual}
                                  </span>
                                </div>
                              </li>
                            )}
                            <li>
                              <div className="pair">
                                <i className="icon-ac"></i>
                                {car.ac ? (
                                  <span>{dictionary.acYes}</span>
                                ) : (
                                  <span>{dictionary.acNo}</span>
                                )}
                              </div>
                            </li>
                            {car.autonomy && (
                              <li>
                                <div className="pair">
                                  <i className="icon-battery-charging"></i>
                                  <span>{car.autonomy}</span>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>

                        <div className="s-booking-confirmation__car__image d-lg-none d-block">
                          <img src={car.modelImage} alt={car.model} />
                        </div>

                        <div className="s-booking-confirmation__car__separator d-none d-lg-block mb-16"></div>

                        <div className="s-booking-confirmation__car__extras">
                          <ul className="s-booking-confirmation__car__extras__list">
                            {isPrepaid
                              ? prepaidIncludes().map((extra, index) => (
                                  <li key={index}>
                                    <i className="icon-check"></i>
                                    <span>{extra}</span>
                                  </li>
                                ))
                              : returnIncludes().map((extra, index) => (
                                  <li key={index}>
                                    <i className="icon-check"></i>
                                    <span>{extra}</span>
                                  </li>
                                ))}
                          </ul>
                        </div>

                        {mbData && mbData.milesAccrual > 0 && (
                          <>
                            <div className="s-booking-confirmation__car__miles-accrual">
                              <div className="s-booking-confirmation__car__separator"></div>

                              <div className="s-booking-confirmation__car__miles-accrual__main">
                                <MilesBonusIcon width={108} height={20} />
                                <div className="s-booking-confirmation__car__separator"></div>
                                <span>{getMilesAccrual()}</span>
                              </div>
                              <span className="s-booking-confirmation__car__miles-accrual__info">
                                {getMilesAccrualText()}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="s-booking-confirmation__separator"></div>
                  <div className="s-booking-confirmation__car__right">
                    <SidebarCosts
                      step={4}
                      isPrepaid={isPrepaid}
                      selectedVehicle={selectedVehicle}
                      mbData={mbData}
                      milesNBonusAccount={milesNBonusAccount}
                    />
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          <div className="s-booking-confirmation__separator--sections d-lg-none d-block"></div>
          <div className="s-booking-confirmation__accordion">
            <div className="row" onClick={handleDriverDetailsClick}>
              <div className="mb-24 d-flex align-items-center justify-content-between">
                <span className="s-booking-form__form-group__title">
                  {dictionary.confirmationDriverDetailsLabel}
                </span>
                <i
                  className={`icon-arrow-down arrow ${
                    toggleDriverDetails ? 'open' : ''
                  }`}
                />
              </div>
            </div>

            <Collapse in={toggleDriverDetails}>
              <div className="s-booking-confirmation__wrapper">
                <div className="s-booking-confirmation__driver-details">
                  {personalDetails.firstName && personalDetails.lastName && (
                    <div className="s-booking-confirmation__driver-details__item">
                      <div className="s-booking-confirmation__driver-details__item__title">
                        {dictionary.confirmationDriverNameLabel}
                      </div>
                      <div className="s-booking-confirmation__driver-details__item__value">
                        {personalDetails.firstName} {personalDetails.lastName}
                      </div>
                    </div>
                  )}
                  {personalDetails.age && (
                    <div className="s-booking-confirmation__driver-details__item">
                      <div className="s-booking-confirmation__driver-details__item__title">
                        {dictionary.confirmationDriverAgeLabel}
                      </div>
                      <div className="s-booking-confirmation__driver-details__item__value">
                        {personalDetails.age}33
                      </div>
                    </div>
                  )}
                  {mbData.milesNBonusId && (
                    <div className="s-booking-confirmation__driver-details__item">
                      <div className="s-booking-confirmation__driver-details__item__title">
                        {dictionary.confirmationDriverMilesBonusIdLabel}
                      </div>
                      <div className="s-booking-confirmation__driver-details__item__value">
                        {mbData.milesNBonusId}
                      </div>
                    </div>
                  )}
                  {personalDetails.phone && (
                    <div className="s-booking-confirmation__driver-details__item">
                      <div className="s-booking-confirmation__driver-details__item__title">
                        {dictionary.confirmationDriverPhoneLabel}
                      </div>
                      <div className="s-booking-confirmation__driver-details__item__value">
                        {personalDetails.phone}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Collapse>
          </div>
        </>
      )}
    </>
  )
}

export default BookingConfirmation
